import { Component } from '@angular/core';
import { SpeakerService } from './speaker.service';

declare var $: any;

const hardPass = "Lancaster1964";

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	
	accessible: boolean = false;
	
	constructor(private speakerSrv: SpeakerService) {
	}
	
	passInputChange(currentPass: string) {
		this.speakerSrv.pass = currentPass;
	}
	submit() {
		if (this.speakerSrv.pass != hardPass) {
			alert('Incorrect password');
			$('#passmodal').modal('show');
		} else {
			$('#passmodal').modal('hide');
			this.accessible = true;
		}
	}
	close() {
		if (this.speakerSrv.pass != hardPass) {
			alert('Incorrect password');
			$('#passmodal').modal('show');
		} else {
			$('#passmodal').modal('hide');
			this.accessible = true;
		}
	}
}



// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/app.component.ts